import { createQueryKeys } from "@lukemorales/query-key-factory"

import axios from "@/api/axios"
import { APIFn } from "@/api/utils"

import {
  AddTeacherResponseType,
  InvitedUserData,
  OrganizationUserType,
  UserData,
} from "./types"

export const TeachersQueryKey = createQueryKeys("teachers", {
  organizationUserList: ({
    orgId,
    params,
  }: {
    orgId: string
    params?: Record<string, any>
  }) => ({
    queryKey: ["organization-user-list", orgId, params],
  }),
  retrieveUserDetails: ({
    userId,
    params,
    orgId,
  }: {
    userId: string
    params?: Record<string, any>
    orgId: string
  }) => ({
    queryKey: ["retrieve-user-details", userId, orgId, params],
  }),
  toggleUserStatus: ({
    params,
    orgId,
  }: {
    params?: Record<string, any>
    orgId: string
  }) => ({
    queryKey: ["toggle-user-status", orgId, params],
  }),
  retrieveInvitedUsers: ({ id, orgId }: { id: number; orgId: string }) => ({
    queryKey: ["retrieve-invited-users", id, orgId],
  }),
})

type Resource = {
  organizationUserList: APIFn<OrganizationUserType[], { orgId: string }>
  retrieveUserDetails: APIFn<UserData, { userId: string; orgId: string }>
  toggleUserStatus: APIFn<void, { orgId: string }>
  addTeacher: APIFn<AddTeacherResponseType>
  bulkAddTeacher: APIFn<void>
  retrieveInvitedUsers: APIFn<InvitedUserData, { id: number; orgId: string }>
}

export const TeachersResource: Resource = {
  organizationUserList: ({ urlParams, ...config }) =>
    axios.get(`/v1/organizations/${urlParams.orgId}/users/`, config),

  retrieveUserDetails: ({ urlParams, ...config }) =>
    axios.get(
      `/v1/organizations/${urlParams.orgId}/users/${urlParams.userId}/`,
      config,
    ),

  toggleUserStatus: ({ data, urlParams, ...config }) =>
    axios.put(
      `/eris/v1/organizations/${urlParams.orgId}/users/bulk-update/`,
      data,
      config,
    ),

  addTeacher: ({ data, ...config }) =>
    axios.post(`/eris/v1/organization-invites/create/`, data, config),

  bulkAddTeacher: ({ data, ...config }) =>
    axios.post(`/eris/v1/organization-invites/bulk-create/`, data, config),

  retrieveInvitedUsers: ({ urlParams, ...config }) =>
    axios.get(`/eris/v1/organization-invites/${urlParams.id}/`, config),
}
